import React from 'react';
import { EMPLOYEE_CLIENT_PREFERENCE_STATUS, getClientsNamesByStatus } from '../../utils/employee';

const ClientPreferenceRenderer = ({
  rowData: { employeeClientsPreferences },
  columnData: { mappedClients, clientStatus } = {}
}) => {
  if (!employeeClientsPreferences || !Object.values(EMPLOYEE_CLIENT_PREFERENCE_STATUS).includes(clientStatus)) {
    return <></>;
  }

  return getClientsNamesByStatus({
    employeeClientsPreferences,
    mappedClients,
    clientStatus
  }).join(', ');
};

export default ClientPreferenceRenderer;
